import { create } from 'zustand';

export type ActionPlanAssignBannerItem = {
  id: string;
  title: string;
  body: string;
};

type ActionPlanAssignBannerState = {
  banner: ActionPlanAssignBannerItem | null;
  /** Page đăng ký handler reload (cong-viec-du-an / du-an). */
  reloadHandler: (() => void | Promise<void>) | null;
  showBanner: (payload: {
    dedupeKey: string;
    title: string;
    body: string;
  }) => void;
  dismissBanner: () => void;
  setReloadHandler: (handler: (() => void | Promise<void>) | null) => void;
  triggerReload: () => void | Promise<void>;
};

export const useActionPlanAssignBannerStore = create<ActionPlanAssignBannerState>((set, get) => ({
  banner: null,
  reloadHandler: null,

  showBanner: ({ dedupeKey, title, body }) => {
    set({
      banner: {
        id: dedupeKey ? `${dedupeKey}-${Date.now()}` : `${Date.now()}`,
        title,
        body,
      },
    });
  },

  dismissBanner: () => {
    set({ banner: null });
  },

  setReloadHandler: (handler) => {
    set({ reloadHandler: handler });
  },

  triggerReload: () => {
    const handler = get().reloadHandler;
    if (handler) return handler();
    get().dismissBanner();
  },
}));
